import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const BoutiquePage = () => {
  const [cart, setCart] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<string | null>(null);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortBy, setSortBy] = useState('newest');
  const [imageModal, setImageModal] = useState<{ isOpen: boolean; product: any } | null>(null);

  // Load cart from localStorage on component mount
  useEffect(() => {
    const savedCart = localStorage.getItem('vybe_cart');
    if (savedCart) {
      setCart(JSON.parse(savedCart));
    }
  }, []);

  // Save cart to localStorage whenever cart changes
  useEffect(() => {
    localStorage.setItem('vybe_cart', JSON.stringify(cart));
  }, [cart]);

  const products = [
    // Outerwear
    {
      id: 1,
      name: 'Puffer "Noctis™"',
      price: 75.00,
      originalPrice: 125.00, // 40% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/53e168ca77ee93c1c2941e2a3c661469.jpeg',
      description: 'Mat: 100% Polyester | Doudoune urbaine chaude avec texture brillante.',
      category: 'outerwear',
      material: '100% Polyester',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: true,
      stock: 15,
    },
    {
      id: 2,
      name: 'Bomber "Shadowline™"',
      price: 45.00,
      originalPrice: 75.00, // 40% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/612e6fc673f91050d2b7f9db0f5730d2.jpeg',
      description: 'Mat: Nylon | Bomber classique street, léger avec zip premium.',
      category: 'outerwear',
      material: 'Nylon',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: true,
      stock: 22,
    },
    {
      id: 3,
      name: 'Gilet "Core Vest™"',
      price: 30.00,
      originalPrice: 60.00, // 50% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/9cd7c61a862ac75917788b29228174e0.jpeg',
      description: 'Mat: Cotton blend | Gilet minimaliste sans manches pour layering urbain.',
      category: 'outerwear',
      material: 'Cotton blend',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: false,
      stock: 18,
    },
    {
      id: 4,
      name: 'Blouson "Camo Vintage™"',
      price: 65.00,
      originalPrice: 95.00, // 32% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/6646f9ad0d68d997061164f113e8afa9.jpeg',
      description: 'Mat: Polyester | Look texturé, effet lavé fait main.',
      category: 'outerwear',
      material: 'Polyester',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: false,
      stock: 12,
    },
    {
      id: 5,
      name: 'Blouson "Denim Sherpa™"',
      price: 90.00,
      originalPrice: 150.00, // 40% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/622e0c72a6b856d7f298c2419fc31370.jpeg',
      description: 'Mat: Denim | Veste hiver doublée avec col sherpa synthétique.',
      category: 'outerwear',
      material: 'Denim',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: true,
      stock: 8,
    },

    // Bottoms & Sets
    {
      id: 6,
      name: 'Cargo "Delave™"',
      price: 28.50,
      originalPrice: 47.50, // 40% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/7ca579f45670bd3edef6285e7a112fea.jpeg',
      description: 'Mat: Cotton | Design tactique, chevilles élastiques, multi-poches utilitaires.',
      category: 'bottoms',
      material: 'Cotton',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: false,
      stock: 25,
    },
    {
      id: 7,
      name: 'Ensemble "Grey Vision™"',
      price: 97.50,
      originalPrice: 130.00, // 25% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/396d69da064f2485065e90bf08d19777.jpeg',
      description: 'Mat: Polyester | Tenue 2 pièces coupe-vent avec motif tech.',
      category: 'sets',
      material: 'Polyester',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: true,
      stock: 10,
    },
    {
      id: 8,
      name: 'Ensemble "Urban Fit™"',
      price: 96.00,
      originalPrice: 160.00, // 40% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/0fb42ce183ea25e4a7384d41441a45b3.jpeg',
      description: 'Mat: Polyamide blend | Fonctionnel, coupe moderne oversized.',
      category: 'sets',
      material: 'Polyamide blend',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: true,
      stock: 14,
    },
    {
      id: 9,
      name: 'Set "Earth Lounge™"',
      price: 70.50,
      originalPrice: 94.00, // 25% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/ca5a7876406ff286ff10adb4846e5ab4.jpeg',
      description: 'Mat: Velvet | Texture détendue, élégance street soft-touch.',
      category: 'sets',
      material: 'Velvet',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: false,
      stock: 16,
    },
    {
      id: 10,
      name: 'Ensemble "Denim Code™"',
      price: 76.50,
      originalPrice: 127.50, // 40% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/3dd7927aec6a8cd05b151fbf80c5b08b.jpeg',
      description: 'Mat: Cotton | Costume denim bicolore avec dégradé fade.',
      category: 'sets',
      material: 'Cotton',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: false,
      stock: 11,
    },

    // Tops
    {
      id: 11,
      name: 'T-shirt "Star 28™"',
      price: 29.40,
      originalPrice: 49.00, // 40% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/67ae4700c0d83d12b4754dbc852b4b22.jpeg',
      description: 'Mat: Cotton | Tee oversized deux couches avec patch signature.',
      category: 'tops',
      material: 'Cotton',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: true,
      stock: 30,
    },
    {
      id: 12,
      name: 'Long Sleeve "Minimal Line™"',
      price: 29.40,
      originalPrice: 42.00, // 30% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/bbe36a29ae605ce09cce25ed96e4c547.jpeg',
      description: 'Mat: Cotton | Print minimal propre devant et dos.',
      category: 'tops',
      material: 'Cotton',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: false,
      stock: 28,
    },
    {
      id: 13,
      name: 'Sweater "Floral Knit™"',
      price: 34.50,
      originalPrice: 69.00, // 50% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/ddafb72a53ea6bdbf1fa67bfc9308e97.jpeg',
      description: 'Mat: Viscose blend | Motif fleur tricoté 3D – édition limitée.',
      category: 'tops',
      material: 'Viscose blend',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: true,
      stock: 7,
    },
    {
      id: 14,
      name: 'Sweat "Basic Muse™"',
      price: 31.50,
      originalPrice: 45.00, // 30% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/a235fea5e94d1b08c10465b74859899d.jpeg',
      description: 'Mat: Cotton | Essentiel street quotidien, finition premium.',
      category: 'tops',
      material: 'Cotton',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: false,
      stock: 35,
    },

    // Colorful Essentials
    {
      id: 15,
      name: 'Set "Lounge Pastel™"',
      price: 49.50,
      originalPrice: 66.00, // 25% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/a6d23adad85bf7eb625fd45842a2b562.jpeg',
      description: 'Mat: 95% cotton | Set assorti pastel confortable.',
      category: 'colorful',
      material: '95% cotton',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: false,
      stock: 20,
    },
    {
      id: 16,
      name: 'T-shirt "Essential Uni™"',
      price: 19.50,
      originalPrice: 32.50, // 40% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/b2b7a9393e1fe58a3e7e7bcf63e2138d.jpeg',
      description: 'Mat: Cotton | Tee minimaliste basique, plusieurs couleurs disponibles.',
      category: 'colorful',
      material: 'Cotton',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: false,
      stock: 45,
    },
    {
      id: 17,
      name: 'T-shirt "Core Street™"',
      price: 22.50,
      originalPrice: 37.50, // 40% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/b00ff4173cb132ab84157e34545e5888.jpeg',
      description: 'Mat: 100% cotton | Fit urbain audacieux avec logo graphique.',
      category: 'colorful',
      material: '100% cotton',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: true,
      stock: 38,
    },
    {
      id: 18,
      name: 'Set "Blue Ice™"',
      price: 45.00,
      originalPrice: 75.00, // 40% de réduction
      image: 'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/7398d36c7eef85128128ce8672c10eed.jpeg',
      description: 'Mat: 95% cotton | Silhouette détendue, édition été.',
      category: 'colorful',
      material: '95% cotton',
      sizes: ['S', 'M', 'L', 'XL'],
      isNew: false,
      stock: 23,
    },
  ];

  const categories = [
    { id: 'all', name: 'Tout', icon: 'ri-apps-line' },
    { id: 'new', name: 'Nouveautés', icon: 'ri-star-line' },
    { id: 'outerwear', name: 'Vestes', icon: 'ri-shirt-line' },
    { id: 'tops', name: 'Hauts', icon: 'ri-t-shirt-line' },
    { id: 'bottoms', name: 'Pantalons', icon: 'ri-pants-line' },
    { id: 'sets', name: 'Ensembles', icon: 'ri-stack-line' },
    { id: 'colorful', name: 'Colorés', icon: 'ri-palette-line' },
    { id: 'sale', name: 'Promo', icon: 'ri-fire-line' },
  ];

  const filteredProducts = products.filter(product => {
    if (selectedCategory === 'all') return true;
    if (selectedCategory === 'new') return product.isNew;
    if (selectedCategory === 'sale') return product.originalPrice > product.price;
    return product.category === selectedCategory;
  });

  const sortedProducts = [...filteredProducts].sort((a, b) => {
    switch (sortBy) {
      case 'price-low':
        return a.price - b.price;
      case 'price-high':
        return b.price - a.price;
      case 'newest':
        return b.id - a.id;
      case 'bestseller':
        return b.stock - a.stock;
      default:
        return 0;
    }
  });

  const addToCart = (product: any, size: string) => {
    const cartItem = {
      ...product,
      selectedSize: size,
      quantity: 1,
      cartId: `${product.id}-${size}`,
    };
    
    const existingItemIndex = cart.findIndex(item => item.cartId === cartItem.cartId);
    
    if (existingItemIndex >= 0) {
      const updatedCart = [...cart];
      updatedCart[existingItemIndex].quantity += 1;
      setCart(updatedCart);
    } else {
      setCart([...cart, cartItem]);
    }
    
    window.dispatchEvent(new Event('cartUpdated'));
    
    const notification = document.createElement('div');
    notification.className = 'fixed top-24 right-4 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg z-50 animate-bounce';
    notification.innerHTML = `
      <div class="flex items-center gap-2">
        <i class="ri-check-line"></i>
        <span>Produit ajouté au panier !</span>
      </div>
    `;
    document.body.appendChild(notification);
    
    setTimeout(() => {
      if (document.body.contains(notification)) {
        document.body.removeChild(notification);
      }
    }, 3000);
  };

  const handleBuyNow = async (product: any, size: string, quantity: number = 1) => {
    setIsLoading(product.id);
    
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 15000);
      
      const response = await fetch(`${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/create-payment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY}`,
        },
        body: JSON.stringify({
          productName: `${product.name} - Taille ${size}`,
          price: product.price,
          quantity: quantity,
          productId: product.id,
          size: size,
        }),
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const data = await response.json();
      
      if (data.url) {
        window.location.href = data.url;
      } else {
        throw new Error('URL de paiement non reçue');
      }
    } catch (error) {
      console.error('Erreur:', error);
      
      if (error.name === 'AbortError') {
        alert('La connexion prend trop de temps. Veuillez réessayer.');
      } else {
        alert('Erreur lors de la création du paiement. Veuillez réessayer.');
      }
    } finally {
      setIsLoading(null);
    }
  };

  const openImageModal = (product: any) => {
    setImageModal({ isOpen: true, product });
    document.body.style.overflow = 'hidden';
  };

  const closeImageModal = () => {
    setImageModal(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A]" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      
      <main className="pt-20 pb-16 relative z-10">
        {/* Hero Section */}
        <section className="relative py-16 px-4">
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url('https://public.readdy.ai/ai/img_res/ae2d6bbd7d34650068f0e05f08ab90bd.jpg')`
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/80 via-[#0A0A0A]/60 to-[#0A0A0A]/90"></div>
          </div>
          
          <div className="relative z-10 max-w-7xl mx-auto text-center">
            <h1 className="text-5xl md:text-7xl font-black text-white mb-6 transform hover:scale-105 transition-all duration-500" style={{ fontFamily: 'Poppins, sans-serif', textShadow: '0 0 30px rgba(255, 138, 0, 0.5)' }}>
              VYBE PARIS
            </h1>
            <p className="text-2xl md:text-3xl text-[#EAE7E2] mb-8 font-light">
              "The New Language of Luxury."
            </p>
            <button
              onClick={() => document.getElementById('shop-section')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-gradient-to-r from-[#FF8A00] to-[#FF6B00] text-[#0A0A0A] font-bold px-8 py-4 rounded-full text-lg hover:from-[#FF6B00] hover:to-[#FF8A00] transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-[#FF8A00]/50"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              🛍️ Shop Collection
            </button>
          </div>
        </section>

        {/* Shop Filters */}
        <section id="shop-section" className="px-4 mb-8">
          <div className="max-w-7xl mx-auto">
            {/* Categories */}
            <div className="flex overflow-x-auto gap-3 mb-6 pb-2">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full whitespace-nowrap transition-all duration-300 transform hover:scale-105 ${
                    selectedCategory === category.id
                      ? 'bg-[#FF8A00] text-[#0A0A0A] font-bold shadow-lg'
                      : 'bg-gray-800 text-white hover:bg-gray-700'
                  }`}
                >
                  <i className={category.icon}></i>
                  <span>{category.name}</span>
                </button>
              ))}
            </div>

            {/* Sort Options */}
            <div className="flex items-center justify-between mb-8">
              <p className="text-white">
                <span className="font-bold text-[#FF8A00]">{sortedProducts.length}</span> produits trouvés
              </p>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="bg-gray-800 text-white px-4 py-2 rounded-lg border border-gray-600 focus:border-[#FF8A00] focus:outline-none"
              >
                <option value="newest">Plus récents</option>
                <option value="price-low">Prix croissant</option>
                <option value="price-high">Prix décroissant</option>
                <option value="bestseller">Meilleures ventes</option>
              </select>
            </div>
          </div>
        </section>

        {/* Products Grid */}
        <section className="px-4 pb-20">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-6">
              {sortedProducts.map((product) => (
                <ProductCard
                  key={product.id}
                  product={product}
                  onAddToCart={addToCart}
                  onBuyNow={handleBuyNow}
                  onViewImage={openImageModal}
                  isLoading={isLoading === product.id}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Delivery / Trust Section */}
        <section className="px-4 mb-16">
          <div className="max-w-7xl mx-auto">
            <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-8 text-center">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="flex flex-col items-center gap-3">
                  <i className="ri-truck-line text-3xl text-[#FF8A00]"></i>
                  <p className="text-white font-semibold">Livraison gratuite dès 100€</p>
                  <p className="text-gray-400 text-sm">Expédition rapide mondiale</p>
                </div>
                <div className="flex flex-col items-center gap-3">
                  <i className="ri-secure-payment-line text-3xl text-[#FF8A00]"></i>
                  <p className="text-white font-semibold">Paiement sécurisé</p>
                  <p className="text-gray-400 text-sm">PayPal & Stripe</p>
                </div>
                <div className="flex flex-col items-center gap-3">
                  <i className="ri-time-line text-3xl text-[#FF8A00]"></i>
                  <p className="text-white font-semibold">Traitement rapide</p>
                  <p className="text-gray-400 text-sm">Commandes traitées sous 48h</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Brand Story Footer */}
        <section className="px-4 mb-16">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-white mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Conçu à Paris, fait pour le monde.
            </h2>
            <p className="text-lg text-[#EAE7E2] mb-6 leading-relaxed">
              Chaque pièce de VYBE PARIS mélange design streetwear et savoir-faire haut de gamme.
              Nous croyons que le luxe doit être portable — et accessible à tous.
            </p>
            <Link
              to="/about"
              className="inline-block bg-transparent border border-[#FF8A00] text-[#FF8A00] font-semibold px-8 py-3 rounded-full hover:bg-[#FF8A00] hover:text-[#0A0A0A] transition-all duration-300 transform hover:scale-105"
            >
              En savoir plus sur nous
            </Link>
            
            <div className="flex justify-center gap-6 mt-8">
              <a href="https://instagram.com/maison.zeus" target="_blank" rel="noopener noreferrer" className="text-[#FF8A00] hover:text-white transition-colors duration-300">
                <i className="ri-instagram-line text-2xl"></i>
              </a>
              <a href="https://tiktok.com/@adofficielo" target="_blank" rel="noopener noreferrer" className="text-[#FF8A00] hover:text-white transition-colors duration-300">
                <i className="ri-tiktok-line text-2xl"></i>
              </a>
              <a href="https://youtube.com/@maisonzeus" target="_blank" rel="noopener noreferrer" className="text-[#FF8A00] hover:text-white transition-colors duration-300">
                <i className="ri-youtube-line text-2xl"></i>
              </a>
              <a href="https://maisonzeus.com" target="_blank" rel="noopener noreferrer" className="text-[#FF8A00] hover:text-white transition-colors duration-300">
                <i className="ri-global-line text-2xl"></i>
              </a>
            </div>
          </div>
        </section>
      </main>

      {/* Image Modal */}
      {imageModal?.isOpen && (
        <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="relative max-w-4xl max-h-[90vh] w-full">
            {/* Close Button */}
            <button
              onClick={closeImageModal}
              className="absolute -top-12 right-0 text-white hover:text-[#FF8A00] transition-colors duration-300 z-10"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>
            
            {/* Product Image */}
            <div className="relative bg-gray-900 rounded-lg overflow-hidden">
              <img
                src={imageModal.product.image}
                alt={imageModal.product.name}
                className="w-full h-auto max-h-[80vh] object-contain"
              />
              
              {/* Product Info Overlay */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-6">
                <h3 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {imageModal.product.name}
                </h3>
                <p className="text-gray-300 mb-3">{imageModal.product.description}</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="text-2xl font-bold text-[#FF8A00]">{imageModal.product.price.toFixed(2)}€</span>
                    <span className="text-lg text-gray-400 line-through">{imageModal.product.originalPrice.toFixed(2)}€</span>
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={() => {
                        addToCart(imageModal.product, imageModal.product.sizes[0]);
                        closeImageModal();
                      }}
                      className="bg-transparent border border-[#FF8A00] text-[#FF8A00] font-semibold px-4 py-2 rounded-lg hover:bg-[#FF8A00] hover:text-[#0A0A0A] transition-all duration-300"
                    >
                      <i className="ri-shopping-cart-line mr-2"></i>
                      Ajouter
                    </button>
                    <button
                      onClick={() => {
                        handleBuyNow(imageModal.product, imageModal.product.sizes[0], 1);
                        closeImageModal();
                      }}
                      className="bg-gradient-to-r from-[#FF8A00] to-[#FF6B00] text-[#0A0A0A] font-bold px-4 py-2 rounded-lg hover:from-[#FF6B00] hover:to-[#FF8A00] transition-all duration-300"
                    >
                      <i className="ri-secure-payment-line mr-2"></i>
                      Acheter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

const ProductCard = ({ product, onAddToCart, onBuyNow, onViewImage, isLoading }: any) => {
  const [selectedSize, setSelectedSize] = useState(product.sizes[0]);
  const [isHovered, setIsHovered] = useState(false);

  const discountPercentage = Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100);

  return (
    <div 
      className="bg-gray-900 rounded-lg overflow-hidden hover:transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-2xl hover:shadow-[#FF8A00]/20 relative" 
      data-product-shop
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Badges */}
      <div className="relative">
        {product.isNew && (
          <div className="absolute top-3 left-3 z-10 bg-gradient-to-r from-[#FF8A00] to-[#FF6B00] text-[#0A0A0A] px-2 py-1 rounded-full text-xs font-bold">
            NOUVEAU
          </div>
        )}
        <div className="absolute top-3 right-3 z-10 bg-red-500 text-white px-2 py-1 rounded-full text-xs font-bold">
          -{discountPercentage}%
        </div>
        {product.stock <= 10 && (
          <div className="absolute bottom-3 left-3 z-10 bg-[#0A0A0A]/80 backdrop-blur-sm text-[#FF8A00] px-2 py-1 rounded text-xs font-bold border border-[#FF8A00]/30">
            Stock: {product.stock}
          </div>
        )}
      </div>

      {/* Product Image */}
      <div className="aspect-[4/5] overflow-hidden relative">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/20 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
        
        {/* Floating Add to Cart Button */}
        {isHovered && (
          <div className="absolute inset-0 flex items-center justify-center">
            <button
              onClick={() => onAddToCart(product, selectedSize)}
              className="bg-[#FF8A00] text-[#0A0A0A] font-bold px-6 py-3 rounded-full transform scale-0 hover:scale-100 transition-all duration-300 shadow-lg animate-bounce"
            >
              <i className="ri-shopping-cart-line mr-2"></i>
              Ajouter
            </button>
          </div>
        )}
      </div>

      {/* Product Info */}
      <div className="p-4">
        <h3 className="text-lg font-bold text-white mb-2 hover:text-[#FF8A00] transition-colors duration-300" style={{ fontFamily: 'Poppins, sans-serif' }}>
          {product.name}
        </h3>
        <p className="text-gray-400 text-sm mb-3 line-clamp-2">{product.description}</p>
        
        {/* Price */}
        <div className="flex items-center gap-2 mb-3">
          <span className="text-xl font-bold text-[#FF8A00]">{product.price.toFixed(2)}€</span>
          <span className="text-sm text-gray-500 line-through">{product.originalPrice.toFixed(2)}€</span>
        </div>

        {/* Size Selection */}
        <div className="mb-3">
          <div className="flex gap-1">
            {product.sizes.map((size: string) => (
              <button
                key={size}
                onClick={() => setSelectedSize(size)}
                className={`px-2 py-1 text-xs rounded border transition-all duration-300 ${
                  selectedSize === size
                    ? 'bg-[#FF8A00] text-[#0A0A0A] border-[#FF8A00] font-bold'
                    : 'bg-transparent text-white border-gray-600 hover:border-[#FF8A00]'
                }`}
              >
                {size}
              </button>
            ))}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-2">
          <button
            onClick={() => onViewImage(product)}
            className="flex-1 bg-transparent border border-[#FF8A00] text-[#FF8A00] font-semibold py-2 px-3 rounded-lg hover:bg-[#FF8A00] hover:text-[#0A0A0A] transition-all duration-300 text-center text-sm"
          >
            Voir
          </button>
          <button
            onClick={() => onBuyNow(product, selectedSize, 1)}
            disabled={isLoading}
            className="flex-1 bg-gradient-to-r from-[#FF8A00] to-[#FF6B00] text-[#0A0A0A] font-bold py-2 px-3 rounded-lg hover:from-[#FF6B00] hover:to-[#FF8A00] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-1 text-sm"
          >
            {isLoading ? (
              <div className="w-3 h-3 border-2 border-[#0A0A0A] border-t-transparent rounded-full animate-spin"></div>
            ) : (
              <>
                <i className="ri-secure-payment-line"></i>
                Acheter
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BoutiquePage;
